import gql from 'graphql-tag';

export const removeSessionMutation = gql`
  mutation RemoveSession($id: ID!) {
    removeSession(id: $id)
  }
`;